import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// L'ordre compte : les polices et les jetons avant tout module de composant,
// pour qu'aucune règle de primitive ne soit chargée avant les variables
// qu'elle consomme.
import "./theme/fonts";
import "./theme/tokens.css";
import "./theme/base.css";

// Enregistre GSAP et pose ses valeurs par défaut une fois pour toute
// l'application. Sans cet import au démarrage, le premier composant animé
// enregistrerait les plugins lui-même, au milieu d'un rendu.
import "./motion/gsap";

import { App } from "./App";
import { BrandingProvider } from "./branding";

const racine = document.getElementById("root");
if (racine === null) {
  throw new Error("Élément #root introuvable : index.html a été modifié.");
}

createRoot(racine).render(
  <StrictMode>
    {/* L'identité de l'instance enveloppe tout : la vitrine comme les
        espaces s'affichent à la marque de l'ESN. */}
    <BrandingProvider>
      <App />
    </BrandingProvider>
  </StrictMode>,
);
